export default {
  Insurance: "Insurance",
  AddInsurance: "AddInsurance",
  editInsurance: "EditInsurance",
};
